document.addEventListener("DOMContentLoaded", function () {
    //选择要监听的目标节点
    const targetNode = document.getElementById('sidebar-cart');
    // 观察器的配置（需要观察子节点的变化）
    const config = { childList: true };

    // 当节点发生变化时的回调函数
    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                checkSideCartStatus()
                // After visibility settles: a content swap while the drawer is
                // open may be a new panel state — the impression logger dedupes
                // by signature, so this is cheap to call unconditionally.
                maybeLogImpression()
            }
        }
    };
    // // 创建一个观察器实例并传入回调函数和配置
    const observer = new MutationObserver(callback);
    // // 用观察器实例开始观察目标节点
    observer.observe(targetNode, config);

    /**
     * Shopify CDN URL for a given render width. The variant JSON hands us the
     * full-size src, which is megabytes for a 2000px product shot.
     */
    function sizedImageUrl(url, width) {
        if (!url) return url;
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function _getCurrentVariantFromOptions(productData) {
        var t = !1; // 初始化变量 t 为 false
        // 遍历 productData 的 variants 数组
        productData.variants.forEach(function (n) {

            // 判断当前变体的选项是否与传入参数相匹配
            if (n.option1 == productData.option1 &&
                n.option2 == productData.option2 &&
                n.option3 == productData.option3) {
                t = n; // 如果匹配，将当前变体赋值给变量 t
            }
        });
        // 返回找到的变体，如果没有找到则返回 null
        return t || null;
    }
    function _onVariantChanged(e, t, addToCartButton, n) {
        _updateProductPrices(t, e, n);
        _updateAddToCartButton(t, e, addToCartButton);

    }
    function _updateProductPrices(e, t, k) {
        var priceList = k.querySelectorAll(".ProductItem__PriceList");
        priceList.forEach(function (n) {

            if (e) {
                n.innerHTML = "",
                    n.innerHTML += '<s>RRP</s> <span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney(e.price, window.theme.moneyFormat).replace('.00', '') + "</span> <span style='color:red;'> NOW 100% FREE </span>";
                n.style.display = ""
            } else
                n.style.display = "none"

        });
    }
    // function _updateAddToCartButton(e,tt,addToCartButton) {
    //     var t = addToCartButton
    //     , i = document.createElement("button");
    //     var n = t.closest(".ProductItem");

    //     i.setAttribute("type", "button"),
    //     i.className = "ProductForm__AddToCart Button Button--secondary Button--full !tw-py-2 !tw-px-2 tw-tracking-normal !tw-text-sm",
    //     e ? e.available ? (i.removeAttribute("disabled"),
    //                         i.classList.add(false ? "Button--secondary" : "Button--primary"),
    //                         i.setAttribute("data-action", "add-to-cart"),
    //                         // i.setAttribute("data-discounted-price", discounted_price),
    //                         i.setAttribute("data-current-variant", JSON.stringify(e)),
    //                         void 0 === true || true ? i.innerHTML = '\n ' + window.languages.productFormAddToCart + '\n': i.innerHTML = "" + window.languages.productFormAddToCart + "") : (i.setAttribute("disabled", "disabled"),
    //             i.classList.add("Button--secondary"),
    //             i.removeAttribute("data-action"),
    //             i.innerHTML = window.languages.productFormSoldOut) : (i.setAttribute("disabled", "disabled"),
    //                                                                     i.removeAttribute("data-action"),
    //                                                                     i.classList.add("Button--secondary"),
    //                                                                     i.innerHTML = window.languages.productFormUnavailable),
    //     t.parentNode.replaceChild(i, t)
    //     // idInput.setAttribute("value", e.id)
    // }
    function _updateAddToCartButton(e, tt, addToCartButton) {
        var t = addToCartButton,
            i = document.createElement("button");
        var n = t.closest(".ProductItem");

        i.setAttribute("type", "button");
        i.className = "ProductForm__AddToCart Button Button--secondary Button--full !tw-py-2 !tw-px-2 tw-tracking-normal !tw-text-sm";

        if (e) {
            if (e.available) {
                i.removeAttribute("disabled");
                i.classList.add(false ? "Button--secondary" : "Button--primary");
                i.setAttribute("data-action", "add-to-cart");
                i.setAttribute("data-current-variant", JSON.stringify(e));
                // Use a span so we can hide text during loading with CSS
                // i.innerHTML = '<span class="btn-label">' + (window.languages?.productFormAddToCart || 'Add To Cart') + '</span>';
                i.innerHTML = '<span class="btn-label">' + (window.languages?.productFormAddToCart || 'Add To Cart') + '</span>';

            } else {
                i.setAttribute("disabled", "disabled");
                i.classList.add("Button--secondary");
                i.removeAttribute("data-action");
                i.innerHTML = '<span class="btn-label">' + (window.languages?.productFormSoldOut || 'Sold out') + '</span>';
            }
        } else {
            i.setAttribute("disabled", "disabled");
            i.removeAttribute("data-action");
            i.classList.add("Button--secondary");
            i.innerHTML = '<span class="btn-label">' + (window.languages?.productFormUnavailable || 'Unavailable') + '</span>';
        }

        t.parentNode.replaceChild(i, t);
    }

    /**
     * Fire-and-forget analytics transport (contract: upsell-analytics.md).
     * keepalive lets the request survive a navigation; failures are swallowed
     * and never retried — the backend is idempotent on (uuid, event), and
     * analytics must never break the drawer.
     */
    function sendUpsellAnalytics(payload) {
        try {
            fetch("https://objektslab.co.uk/api/shopify/analysis/drawer-cart-upsell/impressions", {
                body: JSON.stringify(payload),
                credentials: "same-origin",
                method: "POST",
                keepalive: true,
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).catch(function () {});
        } catch (e) { /* never surface */ }
    }

    /**
     * v2 "add" event: the v1 fields (the backend mirrors them into the legacy
     * adds ledger) plus the panel context. cart_upsell_uuid here is the LINE
     * uuid — the same value written to the line's _cart_upsell_uuid property,
     * which is what the order-attribution join lives on. Context is read at
     * click time (pre-add): we record the state that persuaded the customer.
     */
    function logDrawerCartUpsell(drawerCartUpsellUuid, action, variant_id, type) {
        if (action !== 1) return; // the rebuilt panel never emits v1 revokes

        var sb = document.getElementById('sideBar');
        var band = sb ? sb.getAttribute('data-band') : '';
        var currency = sb ? sb.getAttribute('data-currency') : '';
        var payload = {
            event: 'add',
            variant_id: variant_id,
            cart_upsell_uuid: drawerCartUpsellUuid,
            add_to_cart: 1,
            type: type,
            // Derived from type, not read back from the DOM: the panel may
            // re-render between click and this call, and the backend enforces
            // the type<->mode pairing.
            panel_mode: type === 'tier1' ? 'tier1' : 'recs',
            cart_total: sb ? (parseInt(sb.getAttribute('data-cart-total-gbp'), 10) || 0) : 0,
            accepts: sb ? (parseInt(sb.getAttribute('data-upsell-accepts'), 10) || 0) : 0
        };
        if (band) payload.band = band;
        if (/^[A-Z]{3}$/.test(currency || '')) payload.currency = currency;

        sendUpsellAnalytics(payload);
    }

    /**
     * Impression = the panel was actually shown: drawer open AND the panel
     * rendered cards. One exposure per drawer-open; while open, a re-render
     * only counts again if the panel state (mode|band|products) changed —
     * the drawer re-renders on every cart mutation, so an unconditional send
     * would flood. Hidden panel states send nothing by design.
     */
    var upsellImpression = { open: false, lastSig: null };

    function readPanelState() {
        var sb = document.getElementById('sideBar');
        if (!sb || sb.classList.contains('tw-hidden')) return null;
        var mode = sb.getAttribute('data-upsell-type');
        if (mode !== 'tier1' && mode !== 'recs') return null;
        var handles = Array.prototype.map.call(
            sb.querySelectorAll('.productsWrapper [data-handle]'),
            function (el) { return el.getAttribute('data-handle'); }
        ).filter(Boolean);
        if (!handles.length) return null;
        var band = sb.getAttribute('data-band') || '';
        return {
            mode: mode,
            handles: handles,
            band: band,
            cartTotal: parseInt(sb.getAttribute('data-cart-total-gbp'), 10) || 0,
            accepts: parseInt(sb.getAttribute('data-upsell-accepts'), 10) || 0,
            currency: sb.getAttribute('data-currency') || '',
            sig: mode + '|' + band + '|' + handles.join(',')
        };
    }

    function maybeLogImpression() {
        if (!upsellImpression.open) return;
        var s = readPanelState();
        if (!s || s.sig === upsellImpression.lastSig) return;
        upsellImpression.lastSig = s.sig;

        var payload = {
            event: 'impression',
            cart_upsell_uuid: uuidv4(),
            panel_mode: s.mode,
            products: s.handles.slice(0, 6),
            cart_total: s.cartTotal,
            accepts: s.accepts,
            type: 'panel'
        };
        if (s.band) payload.band = s.band;
        if (/^[A-Z]{3}$/.test(s.currency)) payload.currency = s.currency;

        sendUpsellAnalytics(payload);
    }

    // The theme flips aria-hidden on the drawer root when it opens/closes.
    // Each open resets the signature: reopening on the same panel state is a
    // fresh exposure with a fresh uuid.
    new MutationObserver(function () {
        var isOpen = targetNode.getAttribute('aria-hidden') === 'false';
        if (isOpen && !upsellImpression.open) {
            upsellImpression.open = true;
            upsellImpression.lastSig = null;
            maybeLogImpression();
        } else if (!isOpen) {
            upsellImpression.open = false;
        }
    }).observe(targetNode, { attributes: true, attributeFilter: ['aria-hidden'] });
    function checkDuplicateERingValues(handle) {
        // 获取所有具有 data-e-ring 属性的元素
        const elementsWithDataERing = document.querySelector(`[data-e-ring="${handle}"]`);
        const elementsWithSameValue = document.querySelector(`[data-e-ring-upsell="${handle}"]`);

        if (elementsWithDataERing && elementsWithSameValue) {
            return true;
        }

        // 如果遍历结束后没有找到相同值的元素，则返回 false
        return false;
    }
    function copySideCartInfosToSidebar() {
        // 获取所有包含 data-e-ring 属性的元素
        const elementsWithDataERing = document.querySelectorAll('[data-e-ring]');


        // 遍历每个元素
        elementsWithDataERing.forEach(element => {
            // 获取该元素下的 handle
            const handle = element.dataset.eRing;
            // const sideCartInfosHolder = document.querySelector('#sideBar .sideCartInfos--holder');
            let isHandled = checkDuplicateERingValues(handle); // 标记是否已经处理过匹配的 sideCartInfos

            const sideCartInfosHolder = document.querySelector('#sideBar .sideCartInfos--holder');

            if (sideCartInfosHolder && sideCartInfosHolder.childElementCount > 0) {
                // sideCartInfosHolder 不为空并且包含子元素
                // console.log('sideCartInfosHolder 不为空');
                return;
            } else {
                // sideCartInfosHolder 为空或者不包含子元素
                // console.log('sideCartInfosHolder 为空');
            }

            // 检查是否已经选择隐藏该 handle，如果是则跳过
            const isHidden = manageHandleVisibility(handle, 'check');
            if (!isHidden && !isHandled && document.getElementById('sideBar')) {

                document.getElementById('sideBar').setAttribute('data-product', handle);

                // 获取符合规则的 data-e-ring 下的 sideCartInfos
                const sideCartInfos = element.querySelector('.sideCartInfos');

                // 如果存在 sideCartInfos，则复制并插入到 #sideBar 下的 .sideCartInfos--holder 中
                if (sideCartInfos) {

                    const clonedSideCartInfos = sideCartInfos.cloneNode(true);
                    sideCartInfosHolder.appendChild(clonedSideCartInfos);

                    // 移除原始元素
                    sideCartInfos.parentNode.removeChild(sideCartInfos);
                    // 设置标记为已处理
                    isHandled = true;
                }

            }
        });
    }
    function manageHandleVisibility(handle, action = 'check') {
        // 从 localStorage 中获取所有已隐藏的 handle
        const hiddenHandles = JSON.parse(localStorage.getItem('hiddenHandles')) || [];

        // 检查是否存在该 handle
        const isHandleHidden = hiddenHandles.includes(handle);

        if (action === 'check') {
            // 如果是检查操作，返回该 handle 是否隐藏的状态
            return isHandleHidden;
        } else if (action === 'store') {
            // 如果是储存操作，并且 handle 不在已隐藏列表中，添加到列表并更新 localStorage
            if (!isHandleHidden) {
                hiddenHandles.push(handle);
                localStorage.setItem('hiddenHandles', JSON.stringify(hiddenHandles));
            }
        } else if (action === 'remove') {
            // 如果是移除操作，并且 handle 在已隐藏列表中，移除并更新 localStorage
            if (isHandleHidden) {
                const index = hiddenHandles.indexOf(handle);
                hiddenHandles.splice(index, 1);
                localStorage.setItem('hiddenHandles', JSON.stringify(hiddenHandles));
            }
        }
    }

    function removeUnusedHandles() {
        // 获取所有包含 data-e-ring 属性的元素的 handle
        const elementsWithDataERing = document.querySelectorAll('[data-e-ring]');
        const handlesInDOM = Array.from(elementsWithDataERing).map(element => element.dataset.eRing);

        // 从 localStorage 中获取所有已隐藏的 handle
        const hiddenHandles = JSON.parse(localStorage.getItem('hiddenHandles')) || [];

        // 检查是否存在 localStorage 中存在但 DOM 中没有的 handle
        const unusedHandles = hiddenHandles.filter(handle => !handlesInDOM.includes(handle));

        // 移除 localStorage 中不存在于 DOM 中的 handle
        unusedHandles.forEach(handle => {
            manageHandleVisibility(handle, 'remove');
        });
    }

    function checkSideCartStatus() {
        removeUnusedHandles()
        // 调用函数
        copySideCartInfosToSidebar();
        var sideBar = document.getElementById("sideBar");
        var sideCartInfosHolder = document.querySelector(".sideCartInfos--holder");

        // 获取页面中所有具有 data-e-ring="true" 属性的元素
        var elements = document.querySelectorAll('[data-e-ring]');
        // 计算符合条件的元素数量
        var count = elements.length;
        if (count == 0) {
            // 购物车为空就清空已经隐藏的 handles
            localStorage.removeItem("hiddenHandles");
        }




        // 有内容则显示
        if (sideBar) {
            if (sideCartInfosHolder === null || sideCartInfosHolder.innerHTML.trim() === "") {
                sideBar.classList.add('tw-hidden');
                return false;
            } else {
                sideBar.classList.remove('tw-hidden');
            }
        }
    }
    /**
     * Toggle loading UI on the Add-to-Cart button (no dependency on .btn-label)
     * - When loading: disable + append a real spinner element.
     * - When done: remove spinner; optionally flash "Added ✓" then restore.
     */
    function setButtonLoading(btn, isLoading, successFlashText) {
        if (!btn) return;

        // Cache the original plain text the first time
        if (!btn.dataset.originalLabel) {
            // Prefer explicit label span if present, else fallback to button text
            const explicit = btn.querySelector('.btn-label');
            btn.dataset.originalLabel = (explicit ? explicit.textContent : btn.textContent).trim();
        }

        // Try to resolve a label element to edit; fallback to the button itself
        let labelEl = btn.querySelector('.btn-label');
        if (!labelEl) labelEl = btn; // fallback: edit button's textContent directly

        if (isLoading) {
            btn.classList.add('is-loading');
            btn.setAttribute('aria-busy', 'true');
            btn.disabled = true;

            // Append spinner if not present
            if (!btn.querySelector('.btn-spinner')) {
                const sp = document.createElement('span');
                sp.className = 'btn-spinner';
                sp.setAttribute('aria-hidden', 'true');
                btn.appendChild(sp);
            }
            return;
        }

        // Turn off loading
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;

        // Remove spinner if present
        const sp = btn.querySelector('.btn-spinner');
        if (sp) sp.remove();

        // Optional success flash
        if (successFlashText) {
            const original = btn.dataset.originalLabel || 'Add To Cart';
            labelEl.textContent = successFlashText;
            setTimeout(() => {
                if (!labelEl.isConnected) return;
                labelEl.textContent = original;
            }, 1200);
        }
    }

    function initSideCart() {

        document.getElementById('sidebar-cart').addEventListener('change', function (e) {
            // yotpoWidgetsContainer.initWidgets()
            var target = e.target;
            var productData;
            var currentVariant;

            if (target.classList.contains('ColorSwatch__Radio') ||
                target.classList.contains('SizeSwatch__Radio') ||
                target.classList.contains('OptionSwatch__Radio')) {

                var k = target;
                var t = target;
                var n = target.closest(".ProductItem");
                var p = JSON.parse(n.querySelector("[data-product-item-json]").innerHTML);
                productData = p.product;


                let addToCartButton = n.querySelector(".ProductForm__AddToCart");
                var selectedOptions = n.querySelectorAll('input:checked');

                productData.variants.forEach(function (e) {
                    e.id === p.selected_variant_id && (k.currentVariant = e,
                        k.option1 = e.option1,
                        k.option2 = e.option2,
                        k.option3 = e.option3)
                });

                selectedOptions.forEach(function (e) {
                    productData["option" + e.getAttribute("data-option-position")] = e.value;

                });

                if (t.classList.contains('ColorSwatch__Radio')) {
                    e.target.closest('.ProductOptions').querySelector(".ProductForm__SelectedValue").innerHTML = e.target.value;
                }

                if (t.classList.contains('SizeSwatch__Radio')) {
                    if (n.querySelector('.SizeSwatch.is-active')) {
                        n.querySelector('.SizeSwatch.is-active').classList.remove("is-active");
                    }
                }
                if (t.classList.contains('OptionSwatch__Radio')) {
                    if (n.querySelector('.OptionSwatch.is-active')) {
                        n.querySelector('.OptionSwatch.is-active').classList.remove("is-active");
                    }
                }
                var cv = addToCartButton.getAttribute("data-current-variant");
                currentVariant = _getCurrentVariantFromOptions(productData);

                _onVariantChanged(cv, currentVariant, addToCartButton, n);
                if (!currentVariant) {
                    return;
                }
                let data_image_id = currentVariant.featured_image ? currentVariant.featured_image.id : t.getAttribute("data-image-id");
                let data_image_url = currentVariant.featured_image ? currentVariant.featured_image.src : t.getAttribute("data-image-url");

                // Re-point the existing <img> instead of replacing it. The old code
                // swapped in a fresh element carrying only data-src (for the theme's
                // lazy loader, which had already finished scanning the DOM by then),
                // so the image had no dimensions from the click until whenever a src
                // appeared — the panel collapsed and sprang back on every colour
                // change. Keeping the element means the box is never empty, and the
                // square box in upsell-ering-sidecart.css means a swatch photo with a
                // different aspect ratio cannot resize it either.
                var img = n.parentNode.parentNode.querySelector('.variantWrapper [data-handle="' + productData.handle + '"] .CartUpsell__VariantImage');

                if (img && data_image_url && t.classList.contains('ColorSwatch__Radio')) {
                    img.setAttribute('data-image-id', data_image_id || '');
                    img.srcset = [360, 533, 720].map(function (w) {
                        return sizedImageUrl(data_image_url, w) + ' ' + w + 'w';
                    }).join(', ');
                    img.src = sizedImageUrl(data_image_url, 533);
                    if (currentVariant.featured_image && currentVariant.featured_image.alt != null) {
                        img.alt = currentVariant.featured_image.alt;
                    }
                }
            }
        });
        // document.getElementById('sidebar-cart').addEventListener('click', function (e) {
        //   let uuid = uuidv4();
        //     // 检查被点击的元素是否是我们要监听的元素
        //     if (e.target && e.target.matches('.ProductForm__AddToCart')) {
        //         // 处理点击事件的代码
        //     var t = e.target;
        //     var k = e.target.closest(".ProductItem");
        //     //                 if (true) {
        //     e.preventDefault();
        //     var n = k.querySelector(".ProductForm__AddToCart");
        //     n.setAttribute("disabled", "disabled"),
        //     document.dispatchEvent(new CustomEvent("theme:loading:start"));
        //     // var i = k.querySelector('form[action^="/cart/add"]');
        //     t.currentVariant = JSON.parse(n.getAttribute('data-current-variant'));
        //     // var discounted_price = t.currentVariant.price - (k.getAttribute("data-discounted-off") * matchingCurrencyRate);
        //     let side_cart_e_ring = document.getElementById('sideBar').getAttribute('data-product');
        //     // manageHandleVisibility(side_cart_e_ring, 'store');
        //     let formData = {form_type:"product",utf8:"✓",id:t.currentVariant.id,quantity: 1,properties:{_cart_upsell_type:"e-ring upsell", _cart_upsell_product: side_cart_e_ring, _msg: '('+side_cart_e_ring+') Perfect when paired with',_cart_upsell_uuid: uuid}};
        //     if (t.currentVariant.option1) {
        //     formData['option-0'] = t.currentVariant.option1;
        //     }
        //     if (t.currentVariant.option2) {
        //     formData['option-1'] = t.currentVariant.option2;
        //     }
        //     if (t.currentVariant.option3) {
        //     formData['option-2'] = t.currentVariant.option3;
        //     }
        //     fetch("/cart/add.js", {
        //     body: JSON.stringify(formData),
        //     credentials: "same-origin",
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json",
        //         "X-Requested-With": "XMLHttpRequest"
        //     }
        //     }).then(function(e) {
        //         logDrawerCartUpsell(uuid, 1, t.currentVariant.id, 'e-ring upsell');
        //         Shopify.getCart(function(cart) {
        //             document.dispatchEvent(new CustomEvent("theme:loading:end")),
        //             e.ok ? (n.removeAttribute("disabled"),
        //                     document.dispatchEvent(new CustomEvent("product:added",{
        //             bubbles: !0,
        //             detail: {
        //                 variant: t.currentVariant,
        //                 quantity: 1
        //             }
        //             }))) : e.json().then(function(e) {
        //             var t = document.createElement("span");
        //             t.className = "ProductForm__Error Alert Alert--error",
        //                 t.innerHTML = e.description,
        //                 n.removeAttribute("disabled"),
        //                 n.insertAdjacentElement("afterend", t),
        //                 setTimeout(function() {
        //                     t.remove()
        //                 }, 2500)
        //             })
        //         });
        //     }),
        //     e.preventDefault()
        //     }

        // });
        // Delegate Add To Cart on #sidebar-cart
        document.getElementById('sidebar-cart').addEventListener('click', function (e) {
            let uuid = uuidv4();

            // ✅ Use closest so clicks on <span>, <svg>, etc. still hit the button
            const atcBtn = e.target.closest('.ProductForm__AddToCart');
            if (!atcBtn || !this.contains(atcBtn)) return;

            e.preventDefault();

            // Scope
            const productItem = atcBtn.closest('.ProductItem');
            if (!productItem) return;

            // Always reference the button currently in DOM (it may have been replaced)
            let n = productItem.querySelector('.ProductForm__AddToCart') || atcBtn;

            // === Start button-level loading ===
            setButtonLoading(n, true);                      // show spinner + disable
            document.dispatchEvent(new CustomEvent('theme:loading:start')); // optional global overlay

            // Failsafe: the post-add refresh chain (add -> attributes -> getCart)
            // has no error path in Shopify.getCart — if any request is throttled
            // (429) or dropped, the button would spin forever. Unfreeze after 7s;
            // the add itself has usually succeeded, the next drawer render catches up.
            const unfreeze = setTimeout(function () {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                setButtonLoading(n, false);
            }, 7000);

            // Read current variant from data attribute (set by _updateAddToCartButton)
            try {
                const cv = n.getAttribute('data-current-variant');
                atcBtn.currentVariant = cv ? JSON.parse(cv) : null;
            } catch (_) { atcBtn.currentVariant = null; }

            const v = atcBtn.currentVariant;
            if (!v) {
                setButtonLoading(n, false);
                return;
            }

            const sideBarEl = document.getElementById('sideBar');
            const side_cart_e_ring = sideBarEl.getAttribute('data-product');
            // 'tier1' = discounted promo band (£50-94.99). The Function only
            // discounts lines carrying _cart_upsell_type:"tier1"; everything
            // else keeps the legacy label for the analytics pipeline.
            const upsellType = sideBarEl.getAttribute('data-upsell-type') === 'tier1'
                ? 'tier1'
                : 'e-ring upsell';

            const formData = {
                form_type: 'product',
                utf8: '✓',
                id: v.id,
                quantity: 1,
                properties: {
                    _cart_upsell_type: upsellType,
                    _cart_upsell_product: side_cart_e_ring,
                    _msg: '(' + side_cart_e_ring + ') ' + (upsellType === 'tier1' ? 'Complete your stack' : 'Perfect when paired with'),
                    _cart_upsell_uuid: uuid,
                },
            };
            if (v.option1) formData['option-0'] = v.option1;
            if (v.option2) formData['option-1'] = v.option2;
            if (v.option3) formData['option-2'] = v.option3;

            fetch('/cart/add.js', {
                body: JSON.stringify(formData),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then(function (res) {
                    logDrawerCartUpsell(uuid, 1, v.id, upsellType);

                    // Tier-1 taken: persist the cart-level flag BEFORE the drawer
                    // re-renders so the panel switches to the full-price branch.
                    // Only a tier-1 add counts — taking a full-price card is not
                    // accepting an upsell and must not suppress a promo band the
                    // customer has not been offered yet.
                    // Survives line removal by design (no re-offer; see contract).
                    const markTaken = (upsellType === 'tier1' && res.ok)
                        ? fetch('/cart/update.js', {
                              body: JSON.stringify({ attributes: { _upsell_taken: 'true' } }),
                              credentials: 'same-origin',
                              method: 'POST',
                              headers: {
                                  'Content-Type': 'application/json',
                                  'X-Requested-With': 'XMLHttpRequest',
                              },
                          }).catch(function () {})
                        : Promise.resolve();

                    markTaken.then(function () {
                    Shopify.getCart(function (cart) {
                        clearTimeout(unfreeze);
                        document.dispatchEvent(new CustomEvent('theme:loading:end'));

                        if (res.ok) {
                            setButtonLoading(n, false, 'Added ✓');    // success flash
                            document.dispatchEvent(new CustomEvent('product:added', {
                                bubbles: true,
                                detail: { variant: v, quantity: 1 }
                            }));
                        } else {
                            res.json().then(function (err) {
                                const msg = document.createElement('span');
                                msg.className = 'ProductForm__Error Alert Alert--error';
                                msg.innerHTML = err.description || 'Failed to add to cart';
                                n.insertAdjacentElement('afterend', msg);
                                setTimeout(() => { msg.remove?.(); }, 2500);
                            }).finally(() => setButtonLoading(n, false));
                        }
                    });
                    });
                })
                .catch(function () {
                    clearTimeout(unfreeze);
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    setButtonLoading(n, false);
                });
        });

        // document.getElementById('sidebar-cart').addEventListener('click', function (e) {
        //     // 检查被点击的元素是否是我们要监听的元素
        //     if (e.target && e.target.matches('.seeOptions')) {
        //       console.log('seeOptions')
        //         let seeOptions = e.target;
        //         let sideCart = e.target.closest('.sideCartInfos')
        //         // 隐藏 .productsWrapper
        //         const productsWrapper = sideCart.querySelector('.productsWrapper');
        //         productsWrapper.style.display = 'none';

        //         document.getElementById('sideBarButton--close').classList.add('tw-hidden');
        //         document.getElementById('sideBarButton--back').classList.remove('tw-hidden');

        //         // 获取当前 .seeOptions 元素的 data-handle 属性值
        //         const handle = seeOptions.getAttribute('data-handle');

        //         // 在 .variantWrapper 下查找相对于 data-handle 的 .ProductItem
        //         const variantWrapper = sideCart.querySelector('.variantWrapper');
        //         const productItems = variantWrapper.querySelectorAll('.ProductItem');

        //         // 遍历 .ProductItem 元素
        //         productItems.forEach(productItem => {
        //             // 获取当前 .ProductItem 元素的 data-handle 属性值
        //             const productHandle = productItem.getAttribute('data-handle');

        //             // 如果当前 .ProductItem 元素的 data-handle 属性值与所点击的 .seeOptions 元素的 data-handle 属性值相等
        //             // 则显示该 .ProductItem 元素，否则隐藏
        //             if (productHandle === handle) {
        //                 productItem.style.display = 'block';
        //             } else {
        //                 productItem.style.display = 'none';
        //             }
        //         });
        //     }
        // });
        document.getElementById('sidebar-cart').addEventListener('click', function (e) {
            // Find the nearest .seeOptions from the actual click target
            const seeOptions = e.target.closest('.seeOptions');
            // Guard: no .seeOptions in the click path or it's outside the delegation root
            if (!seeOptions || !this.contains(seeOptions)) return;

            console.log('seeOptions');

            // Scope to the correct side cart block
            const sideCart = seeOptions.closest('.sideCartInfos');
            if (!sideCart) return;

            // Hide productsWrapper
            const productsWrapper = sideCart.querySelector('.productsWrapper');
            if (productsWrapper) productsWrapper.style.display = 'none';

            // Toggle header buttons
            const closeBtn = document.getElementById('sideBarButton--close');
            const backBtn = document.getElementById('sideBarButton--back');
            if (closeBtn) closeBtn.classList.add('tw-hidden');
            if (backBtn) backBtn.classList.remove('tw-hidden');

            // Read the handle from the clicked trigger
            const handle = seeOptions.dataset.handle;

            // Show only the matching product item
            const variantWrapper = sideCart.querySelector('.variantWrapper');
            if (!variantWrapper) return;

            variantWrapper.querySelectorAll('.ProductItem').forEach(item => {
                const productHandle = item.getAttribute('data-handle');
                item.style.display = (productHandle === handle) ? 'block' : 'none';
            });
        });

        // document.getElementById('sidebar-cart').addEventListener('click', function (e) {
        //     if (e.target && e.target.closest('#sideBarButton')) {
        //         const sideBar = document.getElementById('sideBar');
        //         // 找到 productsWrapper 元素
        //         const productsWrapper = sideBar.querySelector('.productsWrapper');

        //         // 找到 variantWrapper 元素
        //         const variantWrapper = sideBar.querySelector('.variantWrapper');

        //         // 判断 productsWrapper 元素的显示状态
        //         if (productsWrapper.style.display === 'block') {
        //             // 如果 productsWrapper 为显示状态，则隐藏 id 为 sideBar 的元素

        //             // sideBar.style.display = 'none';
        //             sideBar.classList.add('tw-hidden');
        //             // 关闭时将handle 设置为 "hidden"，以便下次加载时保持隐藏状态
        //             let handle = sideBar.getAttribute('data-product');
        //             manageHandleVisibility(handle, 'store');

        //         } else {
        //             // 如果 productsWrapper 为隐藏状态，则隐藏 variantWrapper 下所有的 ProductItem，并显示 productsWrapper
        //             const productItems = variantWrapper.querySelectorAll('.ProductItem');
        //             productItems.forEach(productItem => {
        //               productItem.style.display = 'none';
        //             });
        //             productsWrapper.style.display = 'block';
        //             document.getElementById('sideBarButton--close').classList.remove('tw-hidden');
        //             document.getElementById('sideBarButton--back').classList.add('tw-hidden');
        //         }
        //     }
        // });
        document.getElementById('sidebar-cart').addEventListener('click', function (e) {
            const sideBarBtn = e.target.closest('#sideBarButton');
            if (!sideBarBtn) return;

            const sideBar = document.getElementById('sideBar');
            const productsWrapper = sideBar.querySelector('.productsWrapper');
            const variantWrapper = sideBar.querySelector('.variantWrapper');
            const backBtn = document.getElementById('sideBarButton--back');

            // Only react when back is visible (we're on variant layer)
            const isBackVisible = backBtn && !backBtn.classList.contains('tw-hidden');
            if (!isBackVisible) return;

            // === Back to list ===
            // Hide all ProductItem panels
            variantWrapper.querySelectorAll('.ProductItem').forEach(el => el.style.display = 'none');
            // Show list panel
            productsWrapper.style.display = 'block';
            // Hide back button on list layer
            backBtn.classList.add('tw-hidden');

            // Optional: scroll to top for both panels for clean UX
            productsWrapper.scrollTop = 0;
            variantWrapper.scrollTop = 0;
        });


    }
    initSideCart();
    checkSideCartStatus()
});